<!-- COMMENT OUT large loaders -->
<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">

  <div class="tab-content">
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          
          <!-- Selected Beat Row Table -->
          <div class="table table-hover table-bordered table-striped table-condensed">
            <table class="custom-table" style="border: 1px solid #ddd; border-collapse: collapse; padding: 4px;">
              <thead style="white-space:nowrap;">
                <tr>
                  <th rowspan="2" style="width: 5%;">HO LEID</th>
                  <th rowspan="2" style="width: 4%;">LEID</th>
                  <th rowspan="2" style="width: 4%;">Tax Code</th>
                  <th rowspan="2" style="width: 4%;">Reporting Period</th>
                  <th rowspan="2" style="width: 4%;">ME Code</th>
                  <th rowspan="2" style="width: 5%;">LE Name</th>								
                  <th rowspan="2" style="width: 5%;">Gross Inc/Exp</th>
                  <th rowspan="2" style="width: 5%;">Issue Id</th>
                  <th rowspan="2" style="width: 5%;">Sub Total</th>
                </tr>
              </thead>
              <tbody>
                @for (t of selectedBeatRow; track trackByIndex($index)) {
<tr style="border: 1px solid #ddd;padding: 4px;">
                  <td>{{ t.HO_LEID }}</td>
                  <td>{{ t.LEID }}</td>
                  <td>{{ t.CDR_NO }}</td>
                  <td>{{ t.REPORTING_PERIOD }}</td>
                  <td>{{ t.ME_CODE }}</td>
                  <td>{{ t.LE_NAME }}</td>							
                  <td>{{ t.GIE_SHORT_DESC }}</td>
                  <td>{{ t.ISSUE_KEY }}</td>
                  <td>{{ t.SUB_TOTAL }}</td>
                </tr>
}
              </tbody>
            </table>
          </div>

          <!-- Add Row Button -->
          @if (pshipFlag != 'Y') {
<div style="margin-top: 2px;margin-bottom:10px">
            <i style="font-size:24px; cursor: pointer;"
               class="fa fa-plus-circle color-green" 
               title="Add BEAT Type"
               (click)="addRow()"></i>
          </div>
}
          
          <!-- Main BEAT Type Table -->
          <div style="padding-top: 0 !important;">
            <table class="main-table custom-table" style="min-width: 800px !important; width: 98%; table-layout: fixed;">
              <thead>
                <tr>	
                  <th class="sticky-col" style="text-align: center; width: 3%;"></th>
                  <th class="sticky-col" style="text-align: center; width: 14%;">BEAT Type</th>
                  <th class="sticky-col" style="text-align: center; width: 8%;">BEAT Withhold (%)</th>
                  <th class="sticky-col" style="text-align: center; width: 17%;">Trading Partner</th>
                  <th class="sticky-col" style="text-align: center; width: 14%;">Country</th>
                  <th class="sticky-col" style="text-align: center; width: 11%;">BEAT Payment</th>
                  <th class="sticky-col" style="text-align: center; width: 11%;">BEAT Benefit</th>
                  <th class="sticky-col" style="text-align: center; width: 20%;">Comments</th>					
                </tr>
              </thead>
              <tbody>	
                @for (t of beatTypeList; track trackByIndex(i); let i = $index) {

                  @if (t.OPERATION_TYPE !== 'D') {
<tr 
                      style="padding: 4px;">
                  <td style="width:3%;">
                    @if (pshipFlag != 'Y') {
<i style="font-size:24px; cursor: pointer;"
                       class="fa fa-minus-circle color-red" 
                       title="Remove BEAT Type"
                      
                       (click)="deleteRow(t)"></i>
}
                  </td>
                  
                  <td style="width:14%;">
                    <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="beatTypeOptionsView"
                      [selectType]="'single'" [showSearchbox]="true" [title]="'BEAT Type'" [hideTitleOnInput]="true" [inputAriaLabel]="'BEAT Type'"
                      [(ngModel)]="t.selectedBeatTypeItem" [ngModelOptions]="{standalone: true}"
                      (onSelect)="onBeatTypeRowSelect($event, t)">
                      @for (item of beatTypeOptionsView; track item.value) {
                        <ap-dropdown-list-item #dropdownListItem [item]="item"
                          [ariaLabel]="setFormDropdownAriaLabel(item, 'BEAT Type')"
                          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                      }
                    </ap-dropdown>
                  </td>	
                  
                  <td style="width:8%;">
                    <input [id]="'FTC_BDTL_CD_11' + i" 
                           type="number" 
                           class="form-control custom-textbox" 
                           [(ngModel)]="t.beatWhPercent" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="changeInPercent(i, t.beatWhPercent)"
                           min="0" 
                           max="100"
                           step="0.01"> 							
                  </td>
                  
                  <td style="width:17%;">
                    <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="tradingPartnerOptionsView"
                      [selectType]="'single'" [showSearchbox]="true" [title]="'Trading Partner'" [hideTitleOnInput]="true" [inputAriaLabel]="'Trading Partner'"
                      [(ngModel)]="t.selectedTradingPartnerItem" [ngModelOptions]="{standalone: true}"
                      (onSelect)="onTradingPartnerRowSelect($event, t)">
                      @for (item of tradingPartnerOptionsView; track item.value) {
                        <ap-dropdown-list-item #dropdownListItem [item]="item"
                          [ariaLabel]="setFormDropdownAriaLabel(item, 'Trading Partner')"
                          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                      }
                    </ap-dropdown>
                  </td>
                  
                  <td style="width:14%;">
                    <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="countryOptionsView"
                      [selectType]="'single'" [showSearchbox]="true" [title]="'Country'" [hideTitleOnInput]="true" [inputAriaLabel]="'Country'"
                      [(ngModel)]="t.selectedCountryItem" [ngModelOptions]="{standalone: true}"
                      [disabled]="true"
                      (onSelect)="onCountryRowSelect($event, t)">
                      @for (item of countryOptionsView; track item.value) {
                        <ap-dropdown-list-item #dropdownListItem [item]="item"
                          [ariaLabel]="setFormDropdownAriaLabel(item, 'Country')"
                          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                      }
                    </ap-dropdown>
                  </td>
                  
                  <td style="width:11%;">
                    <input [id]="'FTC_BDTL_CD_14' + i" 
                           type="number" 
                           class="form-control custom-textbox" 
                           [(ngModel)]="t.beat_payment" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateBeatPaymentTotal()"
                           step="0.01"> 							
                  </td>
                  
                  <td style="width:11%;">
                    <input [id]="'FTC_BDTL_CD_15' + i" 
                           type="number" 
                           class="form-control custom-textbox" 
                           [(ngModel)]="t.amount" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateTotal()"
                           step="0.01"> 							
                  </td>
                  
                  <td style="width:20%;">
                    <textarea [id]="'FTC_NOTES_14' + i" 
                              type="text" 
                              class="form-control custom-textbox" 
                              [(ngModel)]="t.comments" 
                              [ngModelOptions]="{standalone: true}"></textarea> 
                  </td>
                  </tr>
}
                
}
                
                <tr>
                  <td style="font-weight: bold; margin-left:5%;padding-left: 4%;" colspan="5">
                    <label><strong>Total</strong></label>
                  </td>								
                  <td style="font-weight: bold;padding-left: 1%;">
                    {{totalBeatPayment ? totalBeatPayment : null}}
                  </td>	
                  <td style="font-weight: bold;padding-left: 1%;">
                    {{total ? total : null}}
                  </td>
                  <td style="font-weight: bold;padding-left: 1%;"></td>
                </tr>	
              </tbody>
            </table>
          </div>
          
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked || pshipFlag == 'Y'" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          [disabled]="isSaveClicked || pshipFlag == 'Y'"
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
